import api from "./index";

export async function createCourts(params, body) {
  return api.post(`/varas`, body, { params });
}
export async function updateCourts(id, body) {
  return api.put(`/varas/${id}`, body);
}

export async function getCourts(params) {
  return api.get(`/varas`, { params: params });
}

export async function getCourt(id) {
  return api.get(`/varas/${id}`);
}

export async function deleteCourt(id) {
  return api.delete(`/varas/${id}`);
}

export async function createCourtCalendar(id) {
  return api.post(`/varas/${id}/calendar`);
}
